"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _makeRequest = _interopRequireDefault(require("../../../../common/utils/makeRequest")),
    _queries = require("../queries");

function completeS3MultipartUpload() {
  return _completeS3MultipartUpload.apply(this, arguments);
}

function _completeS3MultipartUpload() {
  return _completeS3MultipartUpload = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(apiClient, uploadId, bucketKey, organisationId, parts) {
    var _yield$makeRequest, data, error;

    return _regenerator["default"].wrap(function (_context) {
      for (;;) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.next = 2, (0, _makeRequest["default"])({
              request: apiClient.query,
              requestParams: {
                query: _queries.completeMultipartUploadQuery,
                variables: {
                  bucketKey: bucketKey,
                  uploadId: uploadId,
                  organisationId: organisationId,
                  parts: parts
                },
                context: {
                  module: "assets"
                }
              }
            });

          case 2:
            if (_yield$makeRequest = _context.sent, data = _yield$makeRequest.data, error = _yield$makeRequest.error, data && data.completeMultipartUpload && !error) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            return _context.abrupt("return", data.completeMultipartUpload);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), _completeS3MultipartUpload.apply(this, arguments);
}

var _default = completeS3MultipartUpload;
exports["default"] = _default;